import { graphqlClient } from '@/services/core/graphqlClient';
import { NOTIFICATIONS_QUERIES } from '@/services/resources';

// Type definitions for notifications
export interface Notification {
    id: string;
    title: string;
    message: string;
    type: string;
    isRead: boolean;
    createdAt: string;
    userId?: string;
    patientId?: string;
}

export interface CommunicationLog {
    id: string;
    patientId: string;
    type: string;
    content: string;
    timestamp: string;
    userId: string;
    status: string;
}

export interface NotificationPreference {
    id: string;
    userId: string;
    type: string;
    enabled: boolean;
    method: string; // email, sms, push
}

/**
 * NotificationsGraphqlService - Handles all notification and communication related GraphQL operations
 * Consumes organized queries from notificationsGquery.ts
 */
export class NotificationsGraphqlService {

  /**
   * Get transfer patient notifications
   */
  async getTransferPatientNotifications(hasuraToken: string) {
    return await graphqlClient.query(
      NOTIFICATIONS_QUERIES.GET_TRANSFER_PATIENT_NOTIFICATIONS,
      {},
      hasuraToken
    );
  }

  /**
   * Get SMS templates
   */
  async getSMSTemplates(hasuraToken: string): Promise<any[]> {
    const result = await graphqlClient.query(
      NOTIFICATIONS_QUERIES.GET_SMS_TEMPLATES,
      {},
      hasuraToken
    );
    return result.data?.api_sms_template || [];
  }
}

// Export singleton instance
export const notificationsGraphqlService = new NotificationsGraphqlService();